module.exports = {
    oidcConfig: {
        jwtSecret: process.env.REACT_APP_OIDC_JWT_SECRET,
        authority: process.env.REACT_APP_OIDC_AUTHORITY,
        client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
        client_secret: process.env.REACT_APP_OIDC_CLIENT_SECRET,
        redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI,
        scope: process.env.REACT_OIDC_SCOPE,
        post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
        automaticSilentRenew: process.env.REACT_APP_OIDC_AUTOMATIC_SILENT_RENEW,
        metadata: {
            jwks_uri: process.env.REACT_APP_OIDC_JWKS_URI,
            token_endpoint: process.env.REACT_APP_OIDC_TOKEN_ENDPOINT,
            issuer: process.env.REACT_APP_OIDC_ISSUER,
            authorization_endpoint: process.env.REACT_APP_OIDC_AUTHORIZATION_ENDPOINT,
            userinfo_endpoint: process.env.REACT_APP_OIDC_USERINFO_ENDPOINT,
            end_session_endpoint: process.env.REACT_APP_OIDC_END_SESSION_ENDPOINT,
            backchannel_logout_supported: process.env.REACT_APP_OIDC_BACKCHANNEL_LOGOUT_SUPPORTED,
            frontchannel_logout_supported: process.env.REACT_APP_OIDC_FRONTCHANNEL_LOGOUT_SUPPORTED,
        },
        onSigninCallback: async ({ state }) => {
            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            );
        },
    },
};